export const DropDownIcon = () => (
  <svg viewBox="0 0 9 4" width={11} height={11}>
    <path d={"M8.19629 0L4.19629 4L0.196289 0H8.19629Z"} fill="black" />
  </svg>
);